module.exports = __webpack_public_path__ + "static/media/playd16.a48b8b20.ico";